import { BoardResponse, ProjectId } from '@business/entities/project';
import { StageId } from '@business/entities/project/ProjectStageResponse';
import { Endpoint } from '../endpoint';

export function fetchBoards(permission = false) {
  return Endpoint.get<BoardResponse[]>(`@gc/project/board`, { params: { permission } });
}

export function fetchBoard(id: string, status = 'active', permission = false) {
  return Endpoint.get<BoardResponse>(`@gc/project/board/board/${id}`, { params: { status, permission } });
}

export function createBoard(data: Partial<BoardResponse>) {
  return Endpoint.post<BoardResponse>(`@gc/project/board`, { data });
}

export function updateBoard(id: string, data: Partial<BoardResponse>) {
  return Endpoint.patch<BoardResponse>(`@gc/project/board/${id}`, { data });
}

export function deleteBoard(id: string) {
  return Endpoint.delete<void>(`@gc/project/board/${id}`);
}

export function orderProjects(stageId: StageId, projects: ProjectId[]) {
  return Endpoint.post<BoardResponse>('@gc/project/board/project-order', { data: { stageId, projects } });
}
